import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a04a42c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "provision_contents_wrapper" }

import Provision from '@/components/Provision.vue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvisionView',
  setup(__props) {

const router = useRouter();
const store = useStore();

const provision = computed(() => {
  return store.getters['provision/provision'];
});

const submit = () => {
  router.push({ name: 'n11' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Provision, {
      provision: _unref(provision),
      onSubmit: submit
    }, null, 8, ["provision"])
  ]))
}
}

})